// api/agingReport.api.ts

import apiHandler from "../../../../api/core/apiHandler";

const agingReportApi = apiHandler("payables/aging");

export default agingReportApi;